import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import Router from 'next/router';
import { Providers } from '@/contexts/Providers';
import { SidebarDrawerContext } from '@/contexts/SidebarDrawerContext';
import { Header } from '../Header';
import { DrawerHeader, Sidebar } from '../Sidebar';
import { Loader } from '../Loader';

const openedDrawerWidth = 280;
const closedDrawerWidth = 65;

function AppLayoutContent({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);
  const { isDrawerOpen } = useContext(SidebarDrawerContext);

  useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      setIsLoading(true);
    });

    Router.events.on('routeChangeComplete', () => {
      setIsLoading(false);
    });

    Router.events.on('routeChangeError', () => {
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <Header />
      <Sidebar />
      {isLoading ? <Loader /> : null}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
          ml: {
            xs: 0,
            lg: `${isDrawerOpen ? openedDrawerWidth : closedDrawerWidth}px`,
          },
        }}
      >
        <DrawerHeader />
        <Container maxWidth="xl">{children}</Container>
      </Box>
    </>
  );
}

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <Providers>
      <AppLayoutContent>{children}</AppLayoutContent>
    </Providers>
  );
}
